import { Container } from 'src/components/common/Container'
import SearchWordInput from 'src/pages/SearchPage/_components/SearchWordInput'
import React, { ReactNode } from 'react'
import { css } from 'styled-components'

const SearchPageLayout = ({ children }: { children: ReactNode }) => {
  return (
    <Container $option="flex_column" $style={S.SearchPageLayoutContainer}>
      <SearchWordInput />
      {children}
    </Container>
  )
}
export default SearchPageLayout

const S = {
  SearchPageLayoutContainer: css`
    flex: 1;
  `,
}
